import React, { useEffect, useState } from 'react';

import axios from 'axios';

import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import 'moment/locale/ko';
import { useRecoilValue } from 'recoil';
import { authAtom } from '_state';
import Box from '@mui/material/Box';
import { useForm } from 'react-hook-form';
import Pagination from '@mui/material/Pagination';
import Container from '@mui/material/Container';
import ExcelUpload from 'components/FileUpload/ExcelUpload';
import FormLabel from '@mui/material/FormLabel';

const columns = [
  { id: 'rowNumber', label: 'No', minWidth: 40, align: 'center' },
  { id: 'userid', label: 'ID', minWidth: 140, align: 'center' },
  { id: 'username', label: '담당자 이름', minWidth: 100, align: 'center' },
  { id: 'eMail', label: '이메일', minWidth: 180, align: 'center' },
  { id: 'phoneNumber', label: '전화번호', minWidth: 180, align: 'center' },
  { id: 'cellPhoneNumber', label: '핸드폰번호', minWidth: 100, align: 'center' },
  { id: 'isActiveNm', label: '사용여부', minWidth: 100, align: 'center' }
];

export default function SubUserMng() {
  const [srchData, setSrchData] = useState({});
  const [datas, setDatas] = useState({});
  const [rows, setRows] = useState([]);
  const [pageCnt, setPageCnt] = useState(1);
  const [page, setPage] = useState(1);
  const [offset] = useState(10);
  const [openExcel, setOpenExcel] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    reset,
    formState: { errors, isDirty }
  } = useForm({
    mode: 'all'
  });

  const auth = useRecoilValue(authAtom);

  const handleChangeSrch = (e) => {
    let id = e.target.id.replace('Srch', '');
    setSrchData({ ...srchData, [id]: e.target.value });
  };

  const handleChange = (e) => {
    setDatas({ ...datas, [e.target.id]: e.target.value });
  };

  const handleChangeRole = (e) => {
    setDatas({ ...datas, Role: { role: e.target.value } });
  };

  const handleRowClick = (data) => (evt) => {
    initForm();
    setDatas(data);
    setValue('datas', data);
  };

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const handleClickOpen = () => {
    setOpenExcel(true);
  };

  const handleClose = () => {
    setOpenExcel(false);
    getDataList();
  };

  const handleClickSetRole = (role) => {
    axios
      .patch(`/api/user/role/${datas.id}`, { role: role })
      .then((response) => {
        alert(response.data.message);
        setDatas({ ...datas, Role: { role: datas.Role.role === 'ROLE_MANAGER' ? 'ROLE_USER' : 'ROLE_MANAGER' } });
        getDataList();
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  const getDataList = async (e) => {
    const { userid, username } = srchData;
    let params = {
      offset,
      page,
      limit: offset,
      userid,
      username,
      companyName: auth.companyName,
      companyNo: auth.companyNo
    };

    const response = await axios.get(`/api/user`, { params });
    if (response.data) {
      const result = response.data;
      setPageCnt(Math.ceil(result.count / offset));
      setRows(result.rows);
      if (e?.target) {
        setPage(1);
      }
    }
  };

  const onClickInit = (evt) => {
    initForm();
  };

  const initForm = () => {
    setDatas({});
    clearErrors();
    reset();
  };

  const userInfoCreate = async (data) => {
    data.role = 'ROLE_USER';
    return await axios.post(`/api/user`, data);
  };

  const userInfoUpdate = async (data) => {
    return await axios.patch(`/api/user/${data.id}`, data);
  };

  const onClickDelete = async (evt) => {
    try {
      if (datas.id === auth.id) {
        alert('자신은 삭제 불가능 합니다.');
        return;
      }

      if (datas.id === datas?.Company?.topManagerId) {
        alert('수석매니저는 삭제 불가능 합니다.');
        return;
      }
      if (datas.id) {
        await axios
          .delete(`/api/user/${datas.id}`)
          .then((response) => {
            getDataList();
            initForm();
            alert(response.data.message);
          })
          .catch((error) => {
            alert(error.response.data.message);
          });
      }
    } catch (e) {
      console.log(`insert failed`);
    }
  };

  const onClickInitPassword = async (evt) => {
    try {
      if (datas.id) {
        await axios
          .patch(`/api/user/initpassword/${datas.id}`)
          .then((response) => {
            alert(response.data.message);
          })
          .catch((error) => {
            alert(error.response.data.message);
          });
      }
    } catch (e) {
      console.log(`insert failed`);
    }
  };

  const createOrUpdate = async (datas) => {
    if (!!datas.id) {
      return await userInfoUpdate(datas);
    } else {
      datas.companyId = auth.companyId;
      return await userInfoCreate(datas);
    }
  };

  const isDuplicationUserid = async (e) => {
    await axios
      .get(`/api/user/isduplicationuserid/${datas.userid}`)
      .then((response) => {
        alert(response.data.message);
        if (response.data.Code) {
          setDatas({ ...datas, userid: '' });
        }
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  const onSubmit = (data) => {
    if (isDirty) {
      createOrUpdate(data.datas)
        .then((response) => {
          getDataList();
          initForm();
          alert(response.data.message);
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    }
  };

  useEffect(async () => {
    getDataList(page);
  }, [page]);

  return (
    <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        서브 계정 관리
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={9}>
          <Stack direction="row" spacing={2}>
            <TextField id="usernameSrch" variant="outlined" size="small" label="사용자명" value={srchData?.username || ''} onChange={handleChangeSrch} />
            <TextField id="useridSrch" variant="outlined" size="small" label="아이디" value={srchData?.userid || ''} onChange={handleChangeSrch} />
            <Button variant="contained" onClick={getDataList}>
              검색
            </Button>
            <Button variant="contained" onClick={handleClickOpen}>
              엑셀 업로드
            </Button>
          </Stack>
          <TableContainer component={'div'}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell key={column.id} align={column.align} sx={{ minWidth: column.minWidth }}>
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, rowIdx) => (
                  <TableRow hover key={row.id} onClick={handleRowClick(row)}>
                    {columns.map((col, colIdx) => (
                      <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                        {row[col.id]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Container maxWidth="sm" sx={{ mt: 2 }}>
              <Pagination count={pageCnt} page={page} onChange={handleChangePage} showFirstButton showLastButton />
            </Container>
          </TableContainer>
        </Grid>
        <Grid item xs={3}>
          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button variant="contained" onClick={onClickInit}>
              초기화
            </Button>
            <Button variant="contained" type="submit" form="userInfoForm" disabled={isDirty && JSON.stringify(datas) !== '{}' ? false : true}>
              {!!datas.id && isDirty ? '수정' : '등록'}
            </Button>
            <Button variant="contained" onClick={onClickDelete} disabled={datas.id && datas.id !== auth.id && datas.id !== datas?.Company?.topManagerId ? false : true}>
              삭제
            </Button>
          </Stack>
          <Box id="userInfoForm" component="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{ mt: 1, minWidth: 300, maxWidth: 500 }}>
            <TextField
              margin="dense"
              required
              sx={{ width: 2 / 3 }}
              id="userid"
              label="ID"
              name="userid"
              value={datas?.userid || ''}
              disabled={datas?.id && true}
              error={!!errors.datas?.userid}
              helperText={errors.datas?.userid && errors.datas?.userid.message}
              {...register('datas.userid', {
                required: 'ID를 입력해주세요.',
                minLength: { value: 5, message: 'ID는 5자 이상입니다.' },
                maxLength: { value: 20, message: 'ID는 20자 이하입니다.' },
                onChange: (e) => handleChange(e)
              })}
            />
            <Button variant="contained" onClick={isDuplicationUserid} size="large" sx={{ width: 0.8 / 3, ml: 2, mt: 1, fontSize: 12, height: 55 }} disabled={!!!datas.id && !!datas.userid ? false : true}>
              중복체크
            </Button>
            <TextField
              margin="dense"
              required={!datas?.id && true}
              name="password"
              label="비밀번호"
              type="password"
              id="password"
              value={datas?.password || ''}
              sx={{ width: 2 / 3 }}
              error={!!errors.datas?.password}
              helperText={errors.datas?.password && errors.datas?.password.message}
              {...register('datas.password', {
                required: !datas?.id && '비밀번호를 입력해주세요.',
                pattern: {
                  value: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d~!@#$%^&*()+|=]{8,20}$/,
                  message: '비밀번호는 8자 이상, 최소 하나의 문자 및 숫자를 입력해주세요.'
                },
                onChange: (e) => handleChange(e)
              })}
            />
            <Button variant="contained" onClick={onClickInitPassword} sx={{ width: 0.8 / 3, ml: 2, mt: 1, fontSize: 12 }} disabled={!!datas.id ? false : true}>
              비밀번호 <br />
              초기화
            </Button>
            <TextField
              margin="dense"
              required
              fullWidth
              name="username"
              label="담당자 이름"
              id="username"
              value={datas?.username || ''}
              error={!!errors.datas?.username}
              helperText={errors.datas?.username && errors.datas?.username.message}
              {...register('datas.username', {
                required: '담당자 이름을 입력해주세요.',
                onChange: (e) => handleChange(e)
              })}
            />
            <TextField
              margin="dense"
              required
              fullWidth
              name="eMail"
              label="E-mail"
              type="text"
              id="eMail"
              value={datas?.eMail || ''}
              error={!!errors.datas?.eMail}
              helperText={errors.datas?.eMail && errors.datas?.eMail.message}
              {...register('datas.eMail', {
                required: '이메일을 입력해주세요.',
                pattern: { value: /^\S+@\S+$/i, message: '이메일 형식을 확인해주세요' },
                onChange: (e) => handleChange(e)
              })}
            />
            <TextField
              margin="dense"
              required
              fullWidth
              name="phoneNumber"
              label="전화번호"
              id="phoneNumber"
              value={datas?.phoneNumber || ''}
              error={!!errors.datas?.phoneNumber}
              helperText={errors.datas?.phoneNumber && errors.datas?.phoneNumber.message}
              {...register('datas.phoneNumber', {
                required: '전화번호를 입력해주세요.',
                pattern: { value: /\d/, message: '숫자만 입력해주세요.' },
                onChange: (e) => handleChange(e)
              })}
            />
            <TextField
              margin="dense"
              required
              fullWidth
              name="cellPhoneNumber"
              label="핸드폰 번호"
              id="cellPhoneNumber"
              value={datas?.cellPhoneNumber || ''}
              error={!!errors.datas?.cellPhoneNumber}
              helperText={errors.datas?.cellPhoneNumber && errors.datas?.cellPhoneNumber.message}
              {...register('datas.cellPhoneNumber', {
                required: '핸드폰번호를 입력해주세요.',
                pattern: { value: /\d/, message: '숫자만 입력해주세요.' },
                onChange: (e) => handleChange(e)
              })}
            />
            {auth.topManagerId == auth.id && (
              <>
                <FormLabel>권한</FormLabel>
                <Button fullWidth variant="contained" disabled={!!datas.id ? false : true} onClick={() => handleClickSetRole(datas.Role.role === 'ROLE_MANAGER' ? 'ROLE_USER' : 'ROLE_MANAGER')}>
                  {datas.Role?.role === 'ROLE_MANAGER' ? '매니저 해제' : '매니저 임명'}
                </Button>
              </>
            )}
          </Box>
        </Grid>
      </Grid>
      <ExcelUpload
        open={openExcel}
        url={`/api/users`}
        sampleFileName="서브 계정"
        rows={[{}]}
        columns={[
          { id: 'userid', label: 'ID' },
          { id: 'password', label: '비밀번호' },
          { id: 'username', label: '담당자 이름' },
          { id: 'eMail', label: 'E-mail' },
          { id: 'phoneNumber', label: '전화번호' },
          { id: 'cellPhoneNumber', label: '핸드폰 번호' }
        ]}
        columnNm={true}
        params={{
          companyName: auth.companyName,
          companyNo: auth.companyNo,
          role: 'ROLE_USER'
        }}
        handleClose={handleClose}
      />
    </Paper>
  );
}
